<h2 mat-dialog-title>Abogado/a</h2>

<form #form="ngForm" #formElement>
  <mat-dialog-content>
    <div class="p-grid p-fluid">
      <div class="p-md-4 p-float-label">
        <input pInputText name="name" required [ngModel]="lawyer.name" />
        <label>Nombre</label>
      </div>

      <div class="p-md-4 p-float-label">
        <input
          pInputText
          name="lastName"
          required
          [ngModel]="lawyer.lastName" />
        <label>Apellidos</label>
      </div>

      <div class="p-md-4 p-float-label">
        <input
          pInputText
          name="identification"
          [ngModel]="lawyer.identification" />
        <label>DNI/NIE</label>
      </div>

      <div class="p-md-8 p-float-label">
        <input
          pInputText
          name="email"
          type="email"
          required
          [ngModel]="lawyer.email" />
        <label>Email</label>
      </div>

      <div class="p-md-2 p-float-label">
        <input
          pInputText
          name="lawyerLicense"
          required
          [ngModel]="lawyer.lawyerLicense" />
        <label>Número abogado/a</label>
      </div>

      <div class="p-md-2 p-float-label">
        <p-dropdown
          name="status"
          optionValue="value"
          optionLabel="label"
          appendTo="body"
          [ngModel]="lawyer.status"
          [options]="[
            { value: 'ACTIVE', label: 'Activo' },
            { value: 'INACTIVE', label: 'Baja colegial' },
            { value: 'TEMPORAL_INACTIVE', label: 'Baja temporal' },
          ]">
        </p-dropdown>
        <label>Estado</label>
      </div>

      <div class="p-md-3 p-float-label">
          <p-calendar
            name="temporalInactiveStart"
            dataType="date"
            dateFormat="dd/mm/yy"
            appendTo="body"
            [ngModel]="lawyer.temporalInactiveStart"
            (ngModelChange)="lawyer.temporalInactiveStart = $event">
          </p-calendar>
          <label>Inicio baja temporal</label>
        </div>
        <div class="p-md-3 p-float-label">
          <p-calendar
            name="temporalInactiveEnd"
            dataType="date"
            dateFormat="dd/mm/yy"
            appendTo="body"
            [ngModel]="lawyer.temporalInactiveEnd"
            (ngModelChange)="lawyer.temporalInactiveEnd = $event">
          </p-calendar>
          <label>Fin baja temporal</label>
        </div>

      <div class="p-md-3 p-float-label">
        <input pInputText name="phoneNumber" [ngModel]="lawyer.phoneNumber" />
        <label>Teléfono</label>
      </div>

      <div class="p-md-3 p-float-label">
        <input pInputText name="telegram" [ngModel]="lawyer.telegram" />
        <label>ID Telegram</label>
      </div>

      <div class="p-md-3 p-float-label">
        <p-dropdown
          [disabled]="!auth.lawyers"
          name="judicialDistrict"
          appendTo="body"
          optionValue="id"
          optionLabel="name"
          placeholder="Selecciona un/a abogado/a"
          [options]="judicialDistricts"
          [ngModel]="lawyer.judicialDistrict?.id"
          (ngModelChange)="onJudicialDistrictChange($event)">
        </p-dropdown>
        <label>Partido judicial</label>
      </div>

      <div class="p-md-6 p-float-label" *ngIf="availableLists.length > 0">
        <p-dropdown
          name="listSelect"
          appendTo="body"
          optionValue="id"
          optionLabel="name"
          placeholder="Añadir lista..."
          [disabled]="!auth.lawyers"
          [options]="availableLists"
          [ngModel]="null"
          [ngModelOptions]="{ standalone: true }"
          (onChange)="onListSelect($event.value)">
        </p-dropdown>
        <label>Listas disponibles</label>
      </div>

      <div class="p-md-12" *ngIf="selectedLists.length > 0">
        <label style="display:block; margin-bottom: 0.5rem; font-size: 0.85rem; color: #6c757d;">Listas seleccionadas</label>
        <div style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
          <span
            *ngFor="let list of selectedLists"
            class="p-tag p-tag-info"
            style="display: inline-flex; align-items: center; gap: 0.25rem; padding: 0.25rem 0.5rem;">
            {{ list.name }}
            <button
              *ngIf="auth.lawyers"
              type="button"
              pButton
              icon="pi pi-times"
              class="p-button-rounded p-button-text p-button-sm"
              style="width: 1rem; height: 1rem; padding: 0;"
              (click)="onListRemove(list)">
            </button>
          </span>
        </div>
      </div>

      <div class="p-md-3 p-float-label">
        <p-dropdown
          name="blockUpdate"
          optionValue="value"
          optionLabel="label"
          appendTo="body"
          [ngModel]="lawyer.blockUpdate"
          [options]="[
            { value: false, label: 'No' },
            { value: true, label: 'Sí' },
          ]">
        </p-dropdown>
        <label>Bloquear actualización</label>
      </div>
    </div>

    <app-graphql-errors
      [errors]="errors"
      [form]="formElement"></app-graphql-errors>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button mat-dialog-close>Cerrar</button>

    <button
      mat-raised-button
      *ngIf="auth.lawyers"
      color="primary"
      [disabled]="!form.valid || !isDateRangeValid"
      (click)="save(form.value)">
      Guardar
    </button>
  </mat-dialog-actions>
</form>
